import React, { FC } from 'react';

import Flex from '../Flex';

import { ContentRowProps } from './ContentRow.types';
import { useAppLayoutGutterSize } from './hooks';

const ContentRow: FC<ContentRowProps> = ({ children, role, grow }) => {
  const gutterSize = useAppLayoutGutterSize();

  return (
    <Flex horizontalPadding={gutterSize} columnGap={gutterSize} grow={grow} role={role} className="qaContentRow">
      {children}
    </Flex>
  );
};

export default ContentRow;
